import BodegasScreen from "../../Screen/ERP/Suministros/Bodegas/BodegasScreen";
import EstantesScreen  from "../../Screen/ERP/Suministros/Estantes/EstantesScreen";
import PosicionesScreen from "../../Screen/ERP/Suministros/Posiciones/PosicionesScreen";
import IngresoBodegaScreen from "../../Screen/ERP/Suministros/Bodegas/IngresosBodega/IngresoBodegaScreen"
import BandejaScreen from "../../Screen/ERP/Suministros/Bandeja/BandejaScreen";
// import IngresoMaterialScreen from "../../Screen/Suministros/Bodegas/RequisasMateriales/";
import RequisasMaterialesScreen from "../../Screen/ERP/Suministros/Bodegas/RequisasMateriales/RequisasMaterialesScreen";
import SalidasMaterialesScreen from "../../Screen/ERP/Suministros/Bodegas/SalidasMateriales/SalidasMaterialesScreen";
import DevolucionesInternasScreen from "../../Screen/ERP/Suministros/Bodegas/DevolucionesInternas/DevolucionesInternasScreen";
import DevolucionesProveedorScreen from "../../Screen/ERP/Suministros/Bodegas/DevolucionesProveedor/DevolucionesProveedorScreen";
import InventarioSuministrosScreen from "../../Screen/ERP/Suministros/Inventario/InventarioSuministrosScreen";

export const SuministrosRoutes = [
  {
    path: "Suministros/Bodega",
    permiso: 15,
    element: <BodegasScreen />,
  },
  {
    path: "Suministros/Estante",
    permiso: 16,
    element: <EstantesScreen />,
  },
  {
    path: "Suministros/Posiciones",
    permiso: 17,
    element: <PosicionesScreen />,
  },
  {
    path: "Suministros/Bandeja",
    permiso: 58,
    element: <BandejaScreen/>,
  },
  {
    path: "Bodega/IngresosBodega",
    permiso: 36,
    element: <IngresoBodegaScreen Bodega={true} MateriaPrima={false} Servicios ={false}/>,
  },
  {
    path: "Bodega/RequisasMateriales",
    permiso: 38,
    element: <RequisasMaterialesScreen />,
  },
  {
    path: "Bodega/RequisasMateriales/Liberar",
    permiso: 39,
    element: <RequisasMaterialesScreen IdPermisoGeneral={6} IdEstado={29}/>,
  },
  {
    path: "Bodega/RequisasMateriales/RRHH",
    permiso: 40,
    element: <RequisasMaterialesScreen IdPermisoGeneral={7} IdEstado={32}/>,
  },
  {
    path: "Bodega/RequisasMateriales/MASS",
    permiso: 41,
    element: <RequisasMaterialesScreen IdPermisoGeneral={8}  IdEstado={32}/>,
  },
  {
    path: "Bodega/SalidaMateriales",
    permiso: 42,
    element: <SalidasMaterialesScreen/>,
  },
  {
    path: "Bodega/DevolucionesInternas",
    permiso: 44,
    element: <DevolucionesInternasScreen/>,
  },
  {
    path: "Bodega/DevolucionesProveedores",
    permiso: 45,
    element: <DevolucionesProveedorScreen/>,
  },
  {
    path: "Bodega/InventarioSuministros",
    permiso: 59,
    element: <InventarioSuministrosScreen/>,
  },
];

export default SuministrosRoutes;
